/*
string
integer
float
flaot2
float3
float4
bool
enum
file
action/button ???
*/

function compareArrays(v1, v2) {
    if (!v1 && !v2) {
        return true;
    }
    if (!v2 || !v2) {
        return false;
    }
    return v1.length == v2.length && v1.every((val, idx) => val === v2[idx]);
}

const CommonPropertyFields = {
    visible: true,
    readOnly: false,
    defaultValue: null,
    cmp_eq: (v1, v2) => { return v1 == v2; },
    deserialize: (str) => { return str; },
    serialize: (val) => { return val; }
}

const PropertyTypes = {
    string: {
        defaultValue: '',
        allowEmpty: true
    },
    integer: {
        defaultValue: 0,
        min: -1000000,
        max: 1000000
    },
    float: {
        defaultValue: '0',
        min: -1000000,
        max: 1000000,

    },
    float2: {
        defaultValue: [0, 0],
        min: -1000000,
        max: 1000000,
        deserialize: (str) => {
            let tokens = str ? str.toString().split(' ') : [];
            return tokens.length == 2
                ? [+tokens[0], +tokens[1]]
                : null;
        },
        serialize: (val) => { return `${val[0]} ${val[1]}`; },
        cmp_eq: compareArrays
    },
    float3: {
        defaultValue: [0, 0, 0],
        min: -1000000,
        max: 1000000,
        deserialize: (str) => {
            let tokens = str ? str.toString().split(' ') : [];
            return tokens.length == 3
                ? [+tokens[0], +tokens[1], +tokens[2]]
                : null;
        },
        serialize: (val) => { return `${val[0]} ${val[1]} ${val[2]}`; },
        cmp_eq: compareArrays
    },
    float4: {
        defaultValue: [0, 0, 0, 0],
        min: -1000000,
        max: 1000000,
        deserialize: (str) => {
            let tokens = str ? str.toString().split(' ') : [];
            return tokens.length == 4
                ? [+tokens[0], +tokens[1], +tokens[2], +tokens[3]]
                : null;
        },
        serialize: (val) => { return `${val[0]} ${val[1]} ${val[2]} ${val[3]}`; },
        cmp_eq: compareArrays
    },
    bool: {
        defaultValue: false,
        deserialize: (str) => {
            switch (str.toString().toLowerCase()) {
                case "true":
                case "1":
                case "on":
                case "yes":
                    return true;
                default:
                    return false;
            }
        },
        serialize: (val) => { return val; }
    },
    enum: {
        defaultValue: '',
        items: [],
    },
    file: {
        defaultValue: '',
        filter: '',
    }
};

function getDataValue(data, path) {
    if (path.length == 0) {
        return null;
    }

    let currentNode = data;
    for (const key of path.split('.')) {
        if (!(key in currentNode)) {
            return null;
        }
        currentNode = currentNode[key];
    }

    return currentNode;
}

function parseProperties(props, data) {
    let result = [];
    for (const prop of props) {
        if ('_group' in prop) {
            let items = parseProperties(prop.items, data);
            result.push({ _group: prop._group, items: items });
            continue;
        }

        let fullProp = {
            ...CommonPropertyFields,
            ...PropertyTypes[prop.type],
            ...prop
        };

        if (!fullProp.visible) {
            continue;
        }

        let value = getDataValue(data, fullProp.path);
        if (value !== null) {
            value = fullProp.deserialize(value);
        } else {
            value = fullProp.defaultValue;
        }
        if (value === null) {
            continue;
        }

        result.push({ ...fullProp, ...{ value: value } });
    }
    return result;
}

function serializeProperties(props)
{
    let result = {};
    for (const prop of props) {
        let tokens = prop.path.split('.');
        let lastKey = tokens.pop();

        let currentNode = result;
        for (const key of tokens) {
            if (currentNode[key] === undefined) {
                currentNode[key] = {};
            }
            currentNode = currentNode[key];
        }
        currentNode[lastKey] = currentValue(prop);
    }
    return result;
}

function currentValue(prop) {
    return 'newValue' in prop ? prop.newValue : prop.value;
}

function updateValue(prop, val)
{
    if (prop.cmp_eq(currentValue(prop), val)) {
        return;
    }
    if ('newValue' in prop && prop.cmp_eq(prop.value, val)) {
        delete prop.newValue;
        return;
    }
    prop.newValue = val;
}

function checkModified(data) {
    if (data._group) {
        if (checkModified(data.items)) {
            return true;
        }
    }
    if (!Array.isArray(data)) {
        return 'newValue' in data;
    }
    for (const prop of data) {
        if (checkModified(prop)) {
            return true;
        }
    }
    return false;
}

function listModified(props)
{
    let result = [];
    for (const prop of props) {
        if (Array.isArray(prop)) {
            let children = listModified(props);
            result = [...result, ...children];
        } else {
            if (prop._group) {
                let children = listModified(prop.items);
                result = [...result, ...children];
            } else {
                if (checkModified(prop)) {
                    result.push(prop);
                }
            }
        }
    }
    return result;
}

function markUnmodified(props)
{
    for (const prop of props) {
        if ('newValue' in prop) {
            prop.value = prop.newValue;
            delete prop.newValue;
        }
    }
}

export default {
    parse: parseProperties,
    serialize: serializeProperties,
    currentValue: currentValue,
    updateValue: updateValue,
    checkModified: checkModified,
    listModified: listModified,
    markUnmodified: markUnmodified
}
